// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1-4g-","header":"PatientQuestionnaire_header__6VO9b","info":"PatientQuestionnaire_info__KJ5G-"};